import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import AfterSalesRefunds from './AfterSalesRefunds.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToMany,
    widget: 'AfterSalesRefunds',
    multi: true
  })
)
export class DetailM2mMultiAfterSalesRefundsFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(AfterSalesRefunds);
    return this;
  }
}